import { render, staticRenderFns } from "./pint7x4reverse.vue?vue&type=template&id=60f70649&scoped=true&"
import script from "./pint7x4reverse.vue?vue&type=script&lang=js&"
export * from "./pint7x4reverse.vue?vue&type=script&lang=js&"
import style0 from "./pint7x4reverse.vue?vue&type=style&index=0&id=60f70649&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f70649",
  null
  
)

export default component.exports